/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useQuery } from '@tanstack/react-query';

/**
 * Export `Me` type.
 */

export type Me = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  profilePhotoUrl: string;
  auth: string;
  hasPassword: boolean;
  isAdmin: boolean;
  isImpersonating?: boolean;
  features?: Record<string, boolean>;
};

/**
 * Export `useMe`.
 *
 * Fetches the current user from `GET /me` (the source of truth for the profile
 * page, kept fresh after edits).
 */

export function useMe() {
  const client = useRequestProvider();

  return useQuery<Me>(['me'], {
    queryFn: async () => client.get(resolveAppUrl('me')).then(({ data }: { data: any }) => data?.data)
  });
}
